import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import Layout from "../../components/Layout";
import SignDownload from "../../components/SignDownload";

const img = "love-it-snap-it-share-it__03.svg";
const path = "love-it-snap-it-share-it-3";

const Page = () => {
    const router = useRouter();
    const phone = typeof router.query.phone === "object" ? router.query.phone[0] : router.query.phone;

    return (
        <>
            <Head>
                <title>Sign Shop - TacBoard</title>
                <meta name="description" content="Free sign generator" />
                <meta name="robots" content="noindex" />
                <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Oswald" />
                <link rel="stylesheet" type="text/css" href="/css/gallery.css" />
            </Head>

            <Layout classes={["sign-shop-sign"]}>
                <SignDownload phone={phone} img={img} filename={`${path}.pdf`} />
            </Layout>
        </>
    );
}

export default Page;
